// Labels are resolved at call time so they follow the active language; the
// `id` of each role is the API value and must never be translated.
export const getMemberRoles = (t) => [
  { id: "creator", label: t("membersList.roles.creator") },
  { id: "member", label: t("membersList.roles.member") },
];

export const getMemberRoleLabels = (t) => ({
  owner: t("membersList.roles.owner"),
  creator: t("membersList.roles.creator"),
  admin: t("membersList.roles.admin"),
  member: t("membersList.roles.member"),
});
